"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.hideGoogleAccountSwitcher = exports.showGoogleAccountSwitcher = exports.hideGoogleDocsPicker = exports.showGoogleDocsPicker = exports.dismissRevertFailedError = exports.dismissFetchRevisionsFailedError = exports.hideRevisions = exports.showRevisions = exports.dismissGoogleDocImportImageUploadError = exports.dismissGoogleDocImportError = exports.dismissGoogleAuthError = exports.showGoogleAuthError = exports.dismissGoogleAuthModal = exports.showGoogleAuthModal = exports.dismissShareModal = exports.showShareModal = void 0;

var _ActionTypes = _interopRequireDefault(require("composer-lib/redux/ActionTypes"));

var _utils = require("composer-lib/lib/utils");

var caShowShareModal = (0, _utils.createAction)(_ActionTypes.default.SHOW_SHARE_MODAL);

var showShareModal = function showShareModal() {
  return function (dispatch) {
    return dispatch(caShowShareModal());
  };
};

exports.showShareModal = showShareModal;
var caDismissShareModal = (0, _utils.createAction)(_ActionTypes.default.DISMISS_SHARE_MODAL);

var dismissShareModal = function dismissShareModal() {
  return function (dispatch) {
    return dispatch(caDismissShareModal());
  };
};

exports.dismissShareModal = dismissShareModal;
var caShowGoogleAuthModal = (0, _utils.createAction)(_ActionTypes.default.SHOW_GOOGLE_AUTH_MODAL);

var showGoogleAuthModal = function showGoogleAuthModal() {
  return function (dispatch) {
    return dispatch(caShowGoogleAuthModal());
  };
};

exports.showGoogleAuthModal = showGoogleAuthModal;
var caDismissGoogleAuthModal = (0, _utils.createAction)(_ActionTypes.default.DISMISS_GOOGLE_AUTH_MODAL);

var dismissGoogleAuthModal = function dismissGoogleAuthModal() {
  return function (dispatch) {
    return dispatch(caDismissGoogleAuthModal());
  };
};

exports.dismissGoogleAuthModal = dismissGoogleAuthModal;
var caShowGoogleAuthError = (0, _utils.createAction)(_ActionTypes.default.SHOW_GOOGLE_AUTH_ERROR);

var showGoogleAuthError = function showGoogleAuthError() {
  return function (dispatch) {
    return dispatch(caShowGoogleAuthError());
  };
};

exports.showGoogleAuthError = showGoogleAuthError;
var caDismissGoogleAuthError = (0, _utils.createAction)(_ActionTypes.default.DISMISS_GOOGLE_AUTH_ERROR);

var dismissGoogleAuthError = function dismissGoogleAuthError() {
  return function (dispatch) {
    return dispatch(caDismissGoogleAuthError());
  };
};

exports.dismissGoogleAuthError = dismissGoogleAuthError;
var caDismissGoogleDocImportError = (0, _utils.createAction)(_ActionTypes.default.DISMISS_GOOGLE_DOC_IMPORT_ERROR);

var dismissGoogleDocImportError = function dismissGoogleDocImportError() {
  return function (dispatch) {
    return dispatch(caDismissGoogleDocImportError());
  };
};

exports.dismissGoogleDocImportError = dismissGoogleDocImportError;
var caDismissGoogleDocImportImageUploadError = (0, _utils.createAction)(_ActionTypes.default.DISMISS_GOOGLE_DOC_IMPORT_IMAGE_UPLOAD_ERROR);

var dismissGoogleDocImportImageUploadError = function dismissGoogleDocImportImageUploadError() {
  return function (dispatch) {
    return dispatch(caDismissGoogleDocImportImageUploadError());
  };
};

exports.dismissGoogleDocImportImageUploadError = dismissGoogleDocImportImageUploadError;
var caShowRevisions = (0, _utils.createAction)(_ActionTypes.default.SHOW_REVISIONS);

var showRevisions = function showRevisions() {
  return function (dispatch) {
    return dispatch(caShowRevisions());
  };
};

exports.showRevisions = showRevisions;
var caHideRevisions = (0, _utils.createAction)(_ActionTypes.default.HIDE_REVISIONS);

var hideRevisions = function hideRevisions() {
  return function (dispatch) {
    return dispatch(caHideRevisions());
  };
};

exports.hideRevisions = hideRevisions;
var caDismissFetchRevisionsFailedError = (0, _utils.createAction)(_ActionTypes.default.DISMISS_FETCH_REVISIONS_FAILED_ERROR);

var dismissFetchRevisionsFailedError = function dismissFetchRevisionsFailedError() {
  return function (dispatch) {
    return dispatch(caDismissFetchRevisionsFailedError());
  };
};

exports.dismissFetchRevisionsFailedError = dismissFetchRevisionsFailedError;
var caDismissRevertFailedError = (0, _utils.createAction)(_ActionTypes.default.DISMISS_REVERT_FAILED_ERROR);

var dismissRevertFailedError = function dismissRevertFailedError() {
  return function (dispatch) {
    return dispatch(caDismissRevertFailedError());
  };
};

exports.dismissRevertFailedError = dismissRevertFailedError;
var caShowGoogleDocsPicker = (0, _utils.createAction)(_ActionTypes.default.SHOW_GOOGLE_DOCS_PICKER);

var showGoogleDocsPicker = function showGoogleDocsPicker() {
  return function (dispatch) {
    return dispatch(caShowGoogleDocsPicker());
  };
};

exports.showGoogleDocsPicker = showGoogleDocsPicker;
var caHideGoogleDocsPicker = (0, _utils.createAction)(_ActionTypes.default.HIDE_GOOGLE_DOCS_PICKER);

var hideGoogleDocsPicker = function hideGoogleDocsPicker() {
  return function (dispatch) {
    return dispatch(caHideGoogleDocsPicker());
  };
};

exports.hideGoogleDocsPicker = hideGoogleDocsPicker;
var caShowGoogleAccountSwitcher = (0, _utils.createAction)(_ActionTypes.default.SHOW_GOOGLE_ACCOUNT_SWITCHER);

var showGoogleAccountSwitcher = function showGoogleAccountSwitcher() {
  return function (dispatch) {
    return dispatch(caShowGoogleAccountSwitcher());
  };
};

exports.showGoogleAccountSwitcher = showGoogleAccountSwitcher;
var caHideGoogleAccountSwitcher = (0, _utils.createAction)(_ActionTypes.default.HIDE_GOOGLE_ACCOUNT_SWITCHER);

var hideGoogleAccountSwitcher = function hideGoogleAccountSwitcher() {
  return function (dispatch) {
    return dispatch(caHideGoogleAccountSwitcher());
  };
};

exports.hideGoogleAccountSwitcher = hideGoogleAccountSwitcher;